import * as THREE from "three"
import { Vector3 } from "three"

export class InteractionPoint extends THREE.Object3D {
  camera: THREE.Camera
  faceCamera: boolean
  clock: THREE.Clock

  isPointActive = true

  constructor(camera: THREE.Camera, faceCamera = true, data = "") {
    super()
    this.camera = camera
    this.faceCamera = faceCamera
    this.clock = new THREE.Clock()
    const loader = new THREE.TextureLoader()
    const geometry = new THREE.PlaneGeometry(0.02, 0.028)
    const material = new THREE.MeshStandardMaterial({
      color: 0xffff00,
      side: THREE.DoubleSide,
    })

    const plane = new THREE.Mesh(geometry, material)
    plane.layers.set(3)
    this.add(plane)
    plane.position.set(0, 0.014, 0)
    plane.rotation.setFromVector3(new Vector3(0, 0, 0))
    plane.userData = { tag: "Point", data: data }
    loader.load(
      // resource URL
      window.location.origin + "/icons/info-point.png",
      // called when the resource is loaded
      function (data) {
        data.generateMipmaps = true
        material.transparent = true
        material.depthWrite = true
        material.side = THREE.DoubleSide
        material.map = data
        material.alphaTest = 0
        material.emissiveMap = data
        material.emissiveIntensity = 1
        material.emissive = new THREE.Color(1, 1, 1)
        material.needsUpdate = true
      },
    )
  }
  update() {
    this.lookAt(this.camera.position)
  }

  zoomPoint(zoom: boolean) {
    if (zoom) this.children[0].scale.set(1.2, 1.2, 1.2)
    else this.children[0].scale.set(1, 1, 1)
  }
}
